export const menusIconConfig = {
  ["/homePage"]: "wodeshouye",
  ["/uiDesign"]: "el-icon-monitor",
  ["/directives"]: "shenshui-zhilingguanli",
  ["/directiveTypes"]: "shenshui-zhilingguanli",
  ["/privateResource"]: "private",
  ["/materials"]: "sucaiguanli",
  ["/projects"]: "gongcheng",
  ["/helps"]: "bangzhuzhongxin",
  ["/userManage"]: "yonghuguanli",
  ["/secretKeys"]: "miyueguanli",
  ["/secretKeys/online"]: "miyueguanli",
  ["/secretKeys/local"]: "el-icon-download",
  ["/secretKeys/hub"]: "el-icon-s-platform",
  ["/roles"]: "jiaoseguanli",
  ["/menus"]: "caidanguanli",
  ["/helpDocuments"]: "jurassic_mge-gcwd",
  ["/templates"]: "moban",
  ["/publicResource"]: "sources",
  ["/clientManage"]: "apk",
  ["/clientManage/apk"]: "apk",
  ["/clientManage/qt"]: "qt",
  ["/clientManage/mac"]: "qt",
  ["/clientManage/ios"]: "qt",
  ["/apk"]: "apk",
  ["/qt"]: "qt"
};
